import flowMixin from '@/modules/Flow/mixins/flowMixin'
import { mapGetters, mapState } from 'vuex'
import { USER_MODULE_NAME } from '@/modules/User/store/types'
import { FLOW_MODULE_NAME } from '@/modules/Flow/store/types'
import { WARRANTY_MODULE_NAME } from '@/store/types'
import { hasRecentlyReportedError, clearErrorFlag } from '@/utils/errorFlag'

/**
 * @module
 * @name Error
 */
export default {
  name: 'Error',
  mixins: [flowMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  computed: {
    ...mapGetters(USER_MODULE_NAME, {
      getUserId: 'userId'
    }),

    ...mapGetters(FLOW_MODULE_NAME, {
      getFlowError: 'flowError'
    }),

    ...mapState(WARRANTY_MODULE_NAME, {
      stateSinisterId: 'sinisterId'
    })
  },
  methods: {
    /**
     * @function
     * @name routeBack
     * @description Push router to go to last route.
     */
    routerBack: function() {
      this.$router.go(-2)
    }
  },
  mounted() {
    // Notify Vue App of the current active element in screen
    this.notifyAppOfChanges(this)

    if (!hasRecentlyReportedError()) {
      // Original behavior if not previous error reported
      // This avoids duplicated reports if error comes from a redirect
      if (this.getUserId && this.stateSinisterId) {
        this.sendSentryError('An error has occurred in the application', 'error', {}, this.stateSinisterId, null, this.getFlowError, this.getUserId, this.prevRoute.path, this.prevRoute.name)
      } else {
        this.sendSentryError('No user data encountered', 'warning', {}, this.stateSinisterId, null, this.getFlowError, null, this.prevRoute.path, this.prevRoute.name)
      }
    }

    localStorage.clear()
    clearErrorFlag()
  }
}
